interface LogoProps {
  className?: string;
  variant?: "full" | "mark";
}

// Logo SyncTech w niebieskiej kolorystyce z gradientem.
export function Logo({ className, variant = "full" }: LogoProps) {
  const gradId = "synctech-grad";
  const defs = (
    <defs>
      <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#0d4f47" />
        <stop offset="50%" stopColor="#14857a" />
        <stop offset="100%" stopColor="#2dd4bf" />
      </linearGradient>
    </defs>
  );

  const tiles = (
    <g transform="translate(66, 66)">
      <rect x="-60" y="-60" width="38" height="38" rx="6" fill="#0d4f47" />
      <rect x="-19" y="-60" width="38" height="38" rx="6" fill="#14857a" />
      <rect x="22" y="-60" width="38" height="38" rx="6" fill="#1aa394" />
      <rect x="-60" y="-19" width="38" height="38" rx="6" fill="#14857a" />
      <rect x="-19" y="-19" width="38" height="38" rx="6" fill="#2dd4bf" />
      <rect x="22" y="-19" width="38" height="38" rx="6" fill="#1aa394" />
      <rect x="-60" y="22" width="38" height="38" rx="6" fill="#1aa394" />
      <rect x="-19" y="22" width="38" height="38" rx="6" fill="#14857a" />
      <rect x="22" y="22" width="38" height="38" rx="6" fill="#0d4f47" />
    </g>
  );

  if (variant === "mark") {
    return (
      <svg viewBox="0 0 132 132" className={className} role="img" aria-label="SyncTech">
        {defs}
        {tiles}
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 420 132" className={className} role="img" aria-label="SyncTech">
      {defs}
      {tiles}
      <text
        x="146"
        y="80"
        fontSize="58"
        fontWeight="800"
        letterSpacing="-2"
        fill="currentColor"
        style={{ fontFamily: "Space Grotesk, system-ui, sans-serif" }}
      >
        sync<tspan fill={`url(#${gradId})`}>tech</tspan>
      </text>
    </svg>
  );
}
